(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/fractiongames/assets/javascript/react/router.js') >= 0) return;  svs.modules.push('/modules/fractiongames/assets/javascript/react/router.js');
"use strict";


const Router = svs.app.ReactRouter.PlayerRouter;
const Route = svs.app.ReactRouter.Route;
const Navigation = svs.fractiongames.components.Navigation;
const WidgetArea = svs.fractiongames.components.WidgetArea;
const GamesPage = svs.fractiongames.pages.GamesPage;
const _svs$fractiongames$co = svs.fractiongames.constants,
  INDEX_ROUTE = _svs$fractiongames$co.INDEX_ROUTE,
  GAMES_ROUTE = _svs$fractiongames$co.GAMES_ROUTE;
const sortedNavItems = () => {
  var _svs$numbergames$frac, _svs$numbergames$frac2;
  const productOrder = (_svs$numbergames$frac = (_svs$numbergames$frac2 = svs.numbergames.fractiongames.data) === null || _svs$numbergames$frac2 === void 0 ? void 0 : _svs$numbergames$frac2.productsSortOrder) !== null && _svs$numbergames$frac !== void 0 ? _svs$numbergames$frac : [];
  const navItems = svs.fractiongames.constants.NAV_ITEMS;
  const navOrder = Array.from(new Set(productOrder.map(product => svs.numbergames.productMapping.getProductName(product))));
  return navItems.sort((a, b) => navOrder.indexOf(a.productName) - navOrder.indexOf(b.productName));
};
const fractionGamesRouter = () => React.createElement(Router, {
  basename: svs.core.data.baseUrl
}, React.createElement(Navigation, {
  navItems: sortedNavItems()
}), React.createElement(Route, {
  exact: true,
  path: INDEX_ROUTE
}, React.createElement(WidgetArea, {
  className: "hero-widget",
  widgetArea: "heroWidget"
})), React.createElement(Route, {
  component: GamesPage,
  exact: true,
  path: GAMES_ROUTE
}));
svs.fractiongames.Router = fractionGamesRouter;

 })(window);